import { Typography, useMediaQuery } from "@mui/material";
import boingoLogoWhite from "../assets/images/Boingo-Logo-White.svg";
import { Box, useTheme } from "@mui/system";
import { Link } from "react-router-dom";

export default function WelcomeFooter() {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  
  return (
    <>
      <Box
        className="welcome-footer"
        data-test-id="welcome-footer"
        sx={{
          "& .MuiTypography-root": {
            color: "rgba(175, 177, 181, 0.9);",
            fontSize: "16px",
          },
        }}
      >
        <img src={boingoLogoWhite} className="boingo-logo-bottom" alt="logo" />
        <Box className="footer-links-wrapper">
          <Box className="footer-links" data-test-id="welcome-footer-links">
            <a
              target="_blank"
              href="https://www.boingo.com/legal/boingo-privacy-policy/"
              data-test-id="welcome-footer-privacy-link"
            >
              Privacy policy
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/website-terms-use-acceptable-use-policy/"
              data-test-id="welcome-footer-terms-link"
            >
              Terms of use
            </a>
            &nbsp;&nbsp;|&nbsp;&nbsp;
            <a
              target="_blank"
              href="https://www.boingo.com/legal/cookie-policy/"
              data-test-id="welcome-footer-cookie-link"
            >
              Cookie policy
            </a>
          </Box>
          <Typography
            className="welcome-footer-support-link"
            data-test-id="welcome-footer-support-link"
          >
            Boingo customer support is available 24/7/365.
          </Typography>
          <Typography
            className="copyright"
            data-test-id="welcome-footer-copyright"
          >
            &copy; {currentYear} Boingo Wireless, Inc. All rights reserved.
          </Typography>
        </Box>
        <Box
          className="dmca"
          data-test-id="dmca"
          sx={{
            "& .MuiTypography-root": {
              fontSize: isMobile ? "14px" : "14px",
              lineHeight: 1.5,
              marginTop: "-10px",
            },
          }}
        >
          <Typography>
            Movies, television shows, music, video games, and other types of
            similar content are protected by copyright, and downloading or
            sharing these materials without permission (for instance from a
            pirate site or a peer-to-peer sharing site) violates federal law.
            Please only access these types of entertainment from appropriate
            websites. Violation of federal copyright protection laws may result
            in substantial civil and financial penalties, including a fine for
            each downloaded file, criminal penalties up to $250,000 and five
            years in prison, and discipline under the Uniform Code of Military
            Justice.
          </Typography>
        </Box>
      </Box>
    </>
  );
}
